import { GridCellProps } from '@progress/kendo-react-grid';
import { SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import GridCellBase from 'src/components/GridCellBase';
import Switch from 'src/components/design-system/Switch';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import { stopPropagation } from 'src/utils';

const BooleanFilterCell: FC<GridCellProps> = (props) => {
  const { t } = useTranslation();
  const { isEditMode, hasEditGLCodePermission, isCheckbookEditable, isPeriodView, isYearEditable } =
    useViewCheckbook();
  const { dataItem, field = '', onChange, dataIndex } = props;
  const { isDeleted, warnings, errors } = dataItem;
  const value = useMemo(() => dataItem?.[field], [dataItem, field]);
  const displayValue = value === true ? t('Yes') : t('No');

  const handleChange = useCallback(
    (e: SwitchChangeEvent) => {
      onChange?.({
        dataIndex: dataIndex,
        dataItem: dataItem,
        field: field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  const hasEditPermission = useMemo(
    () => (isPeriodView ? isCheckbookEditable : isYearEditable),
    [isCheckbookEditable, isPeriodView, isYearEditable]
  );
  const isEditable = useMemo(
    () => isEditMode && hasEditGLCodePermission && !isDeleted && hasEditPermission,
    [isEditMode, hasEditGLCodePermission, isDeleted, hasEditPermission]
  );

  return (
    <GridCellBase
      {...props}
      className={`${
        errors?.[field]?.length
          ? '!bg-error-light'
          : warnings?.[field]?.length
          ? '!bg-warning-light'
          : ''
      } ${isEditMode ? '!text-center' : ''} ${props.className}`}
      rowSelectionEnabled
      title={displayValue}
    >
      {isEditable ? (
        <div onClick={stopPropagation}>
          <Switch value={value} onChange={handleChange} size="small" className={'!w-[54px]'} />
        </div>
      ) : (
        displayValue
      )}
    </GridCellBase>
  );
};

export default BooleanFilterCell;
